<template>
  <ImpersonationBanner />
  <router-view />
  <ToastContainer />
</template>

<script setup>
import ImpersonationBanner from './components/common/ImpersonationBanner.vue';
import ToastContainer from './components/common/ToastContainer.vue';
import { store } from './services/store';

// Route legacy browser alerts through the shared notification design.
window.alert = (message) => {
  store.addNotification(String(message), 'error');
};
</script>

<style>
#app {
  font-family: 'Kanit', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Keep interaction feedback consistent across all screens. Tailwind's
   preflight does not set a pointer cursor for buttons by default. */
button:not(:disabled),
select,
[role="button"],
[role="switch"] {
  cursor: pointer;
}

button:disabled {
  cursor: not-allowed;
}

/* Only hide scrollbars where explicitly requested */
.scrollbar-hide {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.scrollbar-hide::-webkit-scrollbar {
  width: 0;
  height: 0;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

@media screen and (max-width: 1279) {
  body {
    overflow: hidden;
  }
}
</style>
